module.exports = __webpack_public_path__ + "img/celka.f204cdb3.avif";